module.exports = __webpack_public_path__ + "img/symbol_13.cbad9423.png";